import { defineMessages, useIntl } from 'react-intl'
import { useJumpToOptions } from './useJumpToOptions'
import { useQuickActions } from './useQuickActions'
import { ClientNavigationSidebar } from '../../shared/ClientNavigationSidebar/ClientNavigationSidebar'

const MSG = defineMessages({
  yourHomeReport: {
    id: 'HomeownerSideNavigationPanelContents.yourHomeReport',
    defaultMessage: 'Your Home Report'
  }
})

export const HomeownerSidebar = () => {
  const intl = useIntl()
  const jumpToOptions = useJumpToOptions()
  const quickActions = useQuickActions()

  return (
    <ClientNavigationSidebar
      heading={intl.formatMessage(MSG.yourHomeReport)}
      jumpTo={jumpToOptions}
      quickActions={quickActions}
    />
  )
}
